// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import moment from 'moment';

class CheckInOut extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      game_type: '',
      date:moment() ,
      checkList_data:[],
      filtered_data:[],
      checkList_headers: [],
      search:'',
      loading: false
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    
    this.getCheckInOutDetails();
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;

  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getCheckInOutDetails() 
    })
  }

  getCheckInOutDetails() {
    const date = this.state.date.format('YYYY-MM-DD');
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=51001&venue_id=${this.state.venue}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({checkList_data:data.data,checkList_headers:data.headers,program_date_changed:false})
           // alert("fix");
       }).catch(error => error);
  }


  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }
  goBack(){
    this.props.history.goBack();
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  renderCutsomers(){
   
    var headers = []
    if(this.state.checkList_data.length > 0){
      headers = Object.keys(this.state.checkList_data[0])
    }
    
    const headings = this.state.checkList_headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
      <div className='col-md-12 table_container1 table-responsive' style={{'marginTop':20}}>
        { this.state.checkList_data.length > 0 ?
          <ReactTable  
                      data={this.state.checkList_data}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.checkList_data.length > 100}
                      showPaginationTop = {this.state.checkList_data.length > 100}
                      style = {{background:'#9370DB',textAlign:'center'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >
          {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#9370DB'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }
              </ReactTable>
          :
          this.state.checkList_headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      )
  }

  render() {
    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('collection_data',this.state.collection_data)
    return(
      <div>  
          {this.renderCutsomers()}
      </div>
    );
  }
}

export default CheckInOut;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/checkInOut/CheckInOut.js